// Stockaris WMS — Changelog entries (newest first).
// Bump LATEST_VERSION whenever you add a new entry; it auto-opens the drawer
// once per user via localStorage.
export const LATEST_VERSION = '2026.02.13';

export const CHANGELOG = [
  {
    version: '2026.02.13',
    date: 'Feb 13, 2026',
    tag: 'Security · Onboarding',
    items: [
      {
        title: 'Cryptographic SAML signature verification',
        body:
          'Every SAML assertion is now verified with signxml + xmlsec1. Tampered, replayed, or unsigned responses are rejected at the ACS with HTTP 401. A 2048-bit RSA mock IdP keypair is auto-generated for E2E testing.',
        cta: { label: 'Configure SSO', type: 'navigate', to: '/users' },
      },
      {
        title: '5-step Guided Tour for admins',
        body:
          'A branded intro.js walkthrough (Dashboard → Orders → Picking → Shipping → Compliance) auto-launches on your first desktop login. You can restart it anytime from the floating "Take Tour" button.',
        cta: { label: 'Try the Tour now', type: 'tour' },
      },
    ],
  },
  {
    version: '2026.02.10',
    date: 'Feb 10, 2026',
    tag: 'Platform',
    items: [
      {
        title: 'SAML 2.0 SSO (Okta, Azure AD, OneLogin, generic)',
        body:
          'SP-initiated flow with metadata endpoint, Destination/Recipient/NotBefore-NotOnOrAfter checks, and a built-in mock IdP for round-trip testing.',
      },
      {
        title: 'Progressive Web App (PWA) + i18n (EN/ES/FR)',
        body:
          'Install Stockaris to your home screen; language switcher persists per user.',
      },
    ],
  },
  {
    version: '2026.02.05',
    date: 'Feb 5, 2026',
    tag: 'Enterprise',
    items: [
      {
        title: 'Warehouse Health Score + Live WebSocket dashboard',
        body:
          'Composite 0–100 grade blending pick speed, fill rate, stockout risk, count accuracy, and API health. Live event feed streams picks, packs, ships and receipts as they happen.',
        cta: { label: 'View Dashboard', type: 'navigate', to: '/' },
      },
      {
        title: 'Per-user 2FA (TOTP) + CSV batch import wizard',
        body:
          'Enable 2FA with any authenticator app (QR + 8 recovery codes). Bulk-import SKUs, locations, or orders with a validating preview.',
        cta: { label: 'Enable 2FA', type: 'navigate', to: '/security' },
      },
    ],
  },
  {
    version: '2026.02.01',
    date: 'Feb 1, 2026',
    tag: 'Compliance',
    items: [
      {
        title: '7-year data retention & archival',
        body:
          'Per-entity policies auto-archive to `archive_*` collections and delete after the retention window. Browse/restore from the admin UI.',
        cta: { label: 'Manage Retention', type: 'navigate', to: '/retention' },
      },
      {
        title: 'Compliance export + custom report builder',
        body:
          'Download signed ZIP bundles by date range. Build ad-hoc reports by picking entity, fields, and filters.',
        cta: { label: 'Export Compliance ZIP', type: 'navigate', to: '/compliance' },
      },
    ],
  },
];
